module.exports = __webpack_public_path__ + "678de0886fe25ef2ba5c62d8bd05890b.png";